import React, { useEffect } from "react";
import ContainerLandpage from "containers/Landpage02";
import ConectarTV from "components/Landpage02/ConectarTV";
import OnPlanos from "components/Landpage02/OnPlanos";
import OnRodape from "components/Landpage02/OnRodape";

// /tv: destino do QR code da tela de entrada do app da TV (03/10/2026).
// Os planos são os mesmos da página /planos, com o preço normal.
export default function Tv(){
    useEffect(() => {
        document.title = 'Assista a JoinKids na sua TV | JoinKids';
        // Ao sair, a aba volta ao título da marca (o og:title que toda página tem). "O título de antes" não
        // serve: a foto de publicação já guarda esta página com o título dela.
        return () => {
            const marca = document.querySelector('meta[property="og:title"]');
            if (marca && marca.content) document.title = marca.content;
        };
    }, []);

    return (
        <ContainerLandpage>
            <ConectarTV />
            <div id="planos">
                <OnPlanos />
            </div>
            <OnRodape />
        </ContainerLandpage>
    );
}
